import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    flashMessages: {},
  },
  mutations: {
    addFlashMessage(state, payload) {
      (state.flashMessages as any)[payload.key] = payload
    },
    removeFlashMessage(state, key) {
      delete (state.flashMessages as any)[key]
    },
  },
  actions: {
    // How to show flash message from component:
    // Error: $store.dispatch('flashMessage', { type: 'danger', msg: `Error #1: Something unexpected happened` })
    // Success: $store.dispatch('flashMessage', { type: 'success', msg: `Successfully performed XYZ` })
    flashMessage({ commit }, { type, msg }) {
      const key = Math.random()
      commit('addFlashMessage', { key, type, msg })
      setTimeout(() => {
        commit('removeFlashMessage', key)
      }, 10000)
    },
  },
  modules: {
  }
})

export function flashMessage(type: 'danger' | 'warning' | 'success', msg: string) {
  store.dispatch('flashMessage', { type, msg })
}

export default store
